import React, { Component } from 'react';
import isFunction from 'lodash/isFunction';
import { Wrapper } from './PageActionBar.style';

class PageActionBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      saveOnNavigate: undefined,
    };
  }

  componentDidUpdate(prevProps) {
    const { dirty, submitForm } = this.props;

    if (!prevProps.dirty && dirty) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        saveOnNavigate: submitForm,
      });
    } else if (prevProps.dirty && !dirty) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        saveOnNavigate: undefined,
      });
    }
  }

  componentWillUnmount() {
    const { saveOnNavigate } = this.state;

    if (isFunction(saveOnNavigate)) {
      // eslint-disable-next-line no-alert
      if (confirm('This page contains unsaved changes. Save changes?')) {
        saveOnNavigate();
      }
    }
  }

  render() {
    const { children, dirty } = this.props;

    return <Wrapper dirty={dirty}>{children}</Wrapper>;
  }
}

export default PageActionBar;
